// extracted by mini-css-extract-plugin
module.exports = {"footer":"AppFooter_footer__58G2v","container":"AppFooter_container__aYrL_","summary":"AppFooter_summary__MHvMu","social-links":"AppFooter_social-links__d4npE"};